import React from "react";
import { useRouteError } from "react-router-dom";
import img2 from "./../Media/eorror.gif";

const Error = () => {
  const error = useRouteError();
  return (
    <div className="flex justify-center items-center flex-col">
      <img src={img2} alt="" />
    </div>
  );
};

export default Error;
